import styled from "styled-components";
import { media, theme } from "../../theme/theme";
import { CONTENT_LIST_MOBILE_BR } from "../ContentList/ContentList.styles";

const MANUAL_BULK_ADD_MOBILE_BR = 960;

export const ManualSelectBulkWrapper = styled.div<{ $isAboveSrcLimit: boolean}>`
    display: flex;
    max-height: ${({ $isAboveSrcLimit}) => $isAboveSrcLimit? "680px" : "645px"} ;

    > div {
        padding-top: 12px;
        
        &:first-child {
            border-right: 1px solid ${({ theme}) => theme? theme.v3.colors.grey88 : undefined };
            display: none;
            overscroll-behavior: contain;
            overflow-y: auto;
            padding-right: 32px;
            max-height: calc(100vh - 122px);
            margin-left: -22px;
            padding-left: 22px;

            ${media.custom(MANUAL_BULK_ADD_MOBILE_BR)} {
                display: block;
                max-width: 250px;
                width: 100%;
                padding-bottom: 25px;
                margin-bottom: -25px;
            }
        }

        &:nth-child(2) {
            max-height: 500px;

            ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
                max-height: calc(100vh - 146px);
            }
        }
    }
`;

export const ManualBulkShowDesktop = styled.div<{ $desktopDisplay?: string }>`
    display: none;

    ${media.custom(MANUAL_BULK_ADD_MOBILE_BR)} {
        display: block;
    }
`;

export const BulkListContentNavbarWrapper = styled.div`
    padding-left: 20px;
    margin-bottom: 12px;
    margin-left: -22px;

    ${media.custom(CONTENT_LIST_MOBILE_BR)} {
        padding-left: 32px;
    }

    ${media.custom(MANUAL_BULK_ADD_MOBILE_BR)} {
        margin-left: 0;
    }
`;

export const ManualBulkContentListWrapper = styled.div`
    margin-bottom: 24px;
    overflow-y: auto;
    overscroll-behavior: contain;
    height: 100%;
    margin-right: -22px;
    margin-left: -22px;

    ${media.custom(MANUAL_BULK_ADD_MOBILE_BR)} {
        margin-left: 0;
    }
`;

export const ManualBulkRightSidePanel = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

`;

export const ManualBulkMobileFilters = styled.div`
    margin-bottom: 18px;

    ${media.custom(MANUAL_BULK_ADD_MOBILE_BR)} {
        display: none;
    }
`;

export const ManualBulkMobileTypeSrcWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    > div {
        width: calc(50% - 10px);
    }
`;